import {httpService} from "@/modules/common/services";

const list = async (options = {}) => {
  const res = await httpService.get(`bookings`, options);
	if (res.status === "Error") {
		return {error: res.message};
	} else {
		return {bookings: res}
  }
}

const getAvailability = (service_uid, startDateString, endDateString, time_zone, staff_ids, booking_instance_id, aggregate_by, type = "AppointmentService" ) => { //gets availability of a service in the selected month
  const params = {start_date: startDateString, end_date: endDateString, time_zone, include_dst: true, new_api: true, aggregate_by, ignore_min_schedule: true}
  if (staff_ids) {
    params['staff_ids_array'] = typeof staff_ids === 'string' ? staff_ids : staff_ids.join(', ');
  }
  if (booking_instance_id) {
    params.booking_instance_id = booking_instance_id
  }
  if(service_uid) {
    return httpService.get(`platform/v1/services/${service_uid}/availability`, params ).then(res => res.data.availabilities);
  } else {
    params.include_dst = true
    params.type = type
    return httpService.get('platform/v1/staff/availability', params).then(res => res.data.availabilities);
  }
};

export default {
  list,
  getAvailability
}
